// =============================================================================
//  SCREEN: TemplateListScreen (Übersicht aller Urkunden-Vorlagen)
// =============================================================================
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import apiClient from '../api';
import { toast } from 'react-toastify';

const TemplateListScreen = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [templateName, setTemplateName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const { data } = await apiClient.get('/api/templates');
      setTemplates(data);
    } catch (err) {
      toast.error("Vorlagen konnten nicht geladen werden.");
    } finally {
      setLoading(false);
    }
  };

  const handleCreateTemplate = async (e) => {
    e.preventDefault();
    if (!templateName) return toast.error("Bitte einen Namen für die Vorlage eingeben.");
    try {
      const { data: newTemplate } = await apiClient.post('/api/templates', {
        name: templateName,
        elements: JSON.stringify([]) // Leere Elemente beim Erstellen
      });
      toast.success("Vorlage erstellt. Du wirst zum Designer weitergeleitet.");
      navigate(`/vorlagen/${newTemplate._id}`);
    } catch (err) {
      toast.error(err.response?.data?.message || "Fehler beim Erstellen der Vorlage.");
    }
  };

  const handleDeleteTemplate = async (id) => {
    if (window.confirm("Diese Vorlage wirklich löschen?")) {
      try {
        await apiClient.delete(`/api/templates/${id}`);
        toast.success("Vorlage gelöscht.");
        fetchTemplates();
      } catch (err) {
        toast.error("Fehler beim Löschen.");
      }
    }
  };

  if (loading) return <p>Lade Vorlagen...</p>;

  return (
    <div className="screen-container">
      <h2>Urkunden-Vorlagen</h2>
      <div className="form-container-box">
        <h4>Neue Vorlage erstellen</h4>
        <form onSubmit={handleCreateTemplate} className="inline-form">
          <input 
            type="text" 
            value={templateName} 
            onChange={e => setTemplateName(e.target.value)}
            placeholder="Name der neuen Vorlage"
          />
          <button type="submit">+ Erstellen & Bearbeiten</button>
        </form>
      </div>
      
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {templates.map(template => (
              <tr key={template._id}>
                <td>{template.name}</td>
                <td>
                  <Link to={`/vorlagen/${template._id}`} className="btn-edit">Bearbeiten</Link>
                  <button onClick={() => handleDeleteTemplate(template._id)} className="btn-delete">Löschen</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TemplateListScreen;